import styled from 'styled-components';
import { IconsSizes, Media } from 'enums';

export const Icon = styled.img`
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div<{
  paddingMobile?: string;
  paddingDesktop?: string;
  sizeMobile?: IconsSizes;
  sizeDesktop?: IconsSizes;
}>`
  padding: ${({ paddingMobile }) => paddingMobile};
  ${({ sizeMobile }) => ({
    width: sizeMobile ?? IconsSizes.M,
    height: sizeMobile ?? IconsSizes.M,
  })};

  @media ${Media.notebook} {
    padding: ${({ paddingDesktop }) => paddingDesktop};
    ${({ sizeDesktop }) => ({
      width: sizeDesktop ?? IconsSizes.L,
      height: sizeDesktop ?? IconsSizes.L,
    })};
  }
`;
